"use client";

import { createContext } from "react";

import { StrapiCollectionType, StrapiComponentType } from "@/src/type";

export interface PropertyContextType {
  floorplans: StrapiCollectionType.PropertyFloorplan[];
  externalRefId?: string;
  externalRefType?: string;
  unitCarousel?: StrapiComponentType.Object.AssetCaption[];
  filters: Record<string, string | string[]>;
  property: StrapiCollectionType.Property | undefined;
  homesCount: { [key: string]: number };
  updateFilter: (key: string, value: string) => void;
  clearFilters: () => void;
  registerHomeCount: (key: string, count: number) => void;
  filtersQuery: string;
}

export const PropertyContext = createContext<PropertyContextType>({
  floorplans: [],
  externalRefId: undefined,
  externalRefType: undefined,
  unitCarousel: [],
  filters: {},
  property: undefined,
  homesCount: {},
  filtersQuery: "",
  registerHomeCount: () => {},
  updateFilter: () => {},
  clearFilters: () => {},
});
